var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolicyDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_133151",
    "data-name": "Group 133151",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7394",
    "data-name": "Rectangle 7394",
    width: 30,
    height: 30,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_128594",
    "data-name": "Group 128594",
    transform: "translate(4.323 2.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91155",
    "data-name": "Path 91155",
    d: "M232.555,78.488l3.074-5.677A1.6,1.6,0,0,1,237.04,72h12.384a1.6,1.6,0,0,1,1.41.807l3.075,5.677",
    transform: "translate(-232.555 -72.004)",
    fill: "none",
    stroke: "#00bdc7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.591
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91156",
    "data-name": "Path 91156",
    d: "M251.852,98.931h-17.24a2.089,2.089,0,0,1-2.057-2.119V80.858H253.91V96.813A2.089,2.089,0,0,1,251.852,98.931Z",
    transform: "translate(-232.555 -74.231)",
    fill: "none",
    stroke: "#00bdc7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.591
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91157",
    "data-name": "Path 91157",
    d: "M247.883,87.635h0Z",
    transform: "translate(-234.039 -75.016)",
    fill: "none",
    stroke: "#00bdc7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.591
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_184",
    "data-name": "Line 184",
    x2: 11.501,
    transform: "translate(4.927 3.242)",
    fill: "none",
    stroke: "#00bdc7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.591
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyDocumentIcon);
export default __webpack_public_path__ + "static/media/policy_document-icon.0c4c5023a2f7c7a4101e9b385d088ad9.svg";
export { ForwardRef as ReactComponent };